(function () {
  var SPEED_PX_PER_SECOND = 50;
  var RESIZE_DEBOUNCE_MS = 150;
  var MAX_CLONE_SETS = 20;

  function cloneSet(track, sourceItems) {
    sourceItems.forEach(function (item) {
      var clone = item.cloneNode(true);
      clone.removeAttribute("data-ticker-source-item");
      clone.setAttribute("data-ticker-clone-item", "");
      clone.setAttribute("aria-hidden", "true");
      track.appendChild(clone);
    });
  }

  function measureSetWidth(track) {
    var firstSource = track.querySelector("[data-ticker-source-item]");
    var firstClone = track.querySelector("[data-ticker-clone-item]");
    if (!firstSource || !firstClone) return 0;
    return firstClone.getBoundingClientRect().left - firstSource.getBoundingClientRect().left;
  }

  function getAnimationProgress(track) {
    if (typeof track.getAnimations !== "function") return null;
    var animations = track.getAnimations();
    if (!animations.length || !animations[0].effect) return null;
    var timing = animations[0].effect.getComputedTiming();
    if (timing.progress == null) return null;
    return timing.progress;
  }

  function setAnimationProgress(track, progress, durationSeconds) {
    if (progress == null || typeof track.getAnimations !== "function") return;
    var currentTime = progress * durationSeconds * 1000;
    track.getAnimations().forEach(function (animation) {
      animation.currentTime = currentTime;
    });
  }

  function fillClones(track, sourceItems, wrapper, sourceWidth) {
    var minTrackWidth = wrapper.offsetWidth + sourceWidth;
    var safety = 0;
    while (track.scrollWidth < minTrackWidth && safety < MAX_CLONE_SETS) {
      cloneSet(track, sourceItems);
      safety += 1;
    }
  }

  function setupTicker(ticker, options) {
    if (!ticker) return;

    var preservePosition = options && options.preservePosition;
    var track = ticker.querySelector("[data-ticker-track]");
    var wrapper = ticker.querySelector(".announcement-ticker-wrapper");
    if (!track || !wrapper) return;

    var sourceItems = Array.prototype.slice.call(track.querySelectorAll("[data-ticker-source-item]"));
    if (!sourceItems.length) return;

    var progress = preservePosition ? getAnimationProgress(track) : null;

    if (!preservePosition) {
      ticker.classList.remove("is-ready");
      Array.prototype.slice.call(track.querySelectorAll("[data-ticker-clone-item]")).forEach(function (node) {
        node.remove();
      });
    }

    if (!track.querySelector("[data-ticker-clone-item]")) {
      cloneSet(track, sourceItems);
    }

    var sourceWidth = measureSetWidth(track);
    if (sourceWidth <= 0) return;

    fillClones(track, sourceItems, wrapper, sourceWidth);

    var durationSeconds = sourceWidth / SPEED_PX_PER_SECOND;
    var nextDistance = sourceWidth + "px";
    var nextDuration = durationSeconds + "s";
    var distanceChanged = ticker.style.getPropertyValue("--ticker-distance") !== nextDistance;

    ticker.style.setProperty("--ticker-distance", nextDistance);
    ticker.style.setProperty("--ticker-duration", nextDuration);
    ticker.classList.add("is-ready");

    if (progress != null && distanceChanged) {
      requestAnimationFrame(function () {
        setAnimationProgress(track, progress, durationSeconds);
      });
    }
  }

  function setupAllTickers(options) {
    var tickers = document.querySelectorAll("[data-ticker-section-id]");
    tickers.forEach(function (ticker) {
      setupTicker(ticker, options);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      setupAllTickers();
    });
  } else {
    setupAllTickers();
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      setupAllTickers({ preservePosition: true });
    });
  }

  var resizeTimer;
  window.addEventListener("resize", function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      setupAllTickers({ preservePosition: true });
    }, RESIZE_DEBOUNCE_MS);
  });

  document.addEventListener("shopify:section:load", function () {
    setupAllTickers();
  });
})();
